// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1f_ZB","containerItemsCenter":"Skeleton_containerItemsCenter__1kqi0"};